/**
 * Print-route HTML builder for the staff Delivery page.
 * Pure string generation — extracted from Delivery.jsx.
 */

export const buildRouteHTML = (route) => `
  <!DOCTYPE html>
  <html>
  <head>
    <title>Delivery Route - ${route.route_number}</title>
    <style>
      * { margin: 0; padding: 0; box-sizing: border-box; }
      body { font-family: Arial, sans-serif; padding: 20px; font-size: 12px; color: #333; }
      .header { text-align: center; margin-bottom: 25px; border-bottom: 3px solid #000; padding-bottom: 15px; }
      .header h1 { font-size: 22px; margin-bottom: 5px; }
      .header .info { font-size: 14px; color: #666; }
      .summary { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; margin-bottom: 20px; }
      .summary-box { border: 2px solid #333; padding: 10px; text-align: center; }
      .summary-box .number { font-size: 20px; font-weight: bold; }
      .summary-box .label { font-size: 10px; color: #666; }
      .stop { border: 2px solid #333; margin-bottom: 15px; page-break-inside: avoid; }
      .stop-header { background: #f0f0f0; padding: 10px; border-bottom: 2px solid #333; display: flex; justify-content: space-between; }
      .stop-number { font-size: 18px; font-weight: bold; }
      .stop-content { padding: 10px; }
      .client-name { font-size: 16px; font-weight: bold; margin-bottom: 8px; }
      .address { margin-bottom: 8px; }
      .time-slot { color: #666; margin-bottom: 8px; }
      .instructions { background: #fff3cd; padding: 8px; margin-bottom: 8px; font-style: italic; }
      .items { margin-top: 10px; }
      .item { display: flex; justify-content: space-between; padding: 5px 0; border-bottom: 1px dotted #ccc; }
      .checkbox { width: 20px; height: 20px; border: 2px solid #333; margin-right: 10px; display: inline-block; }
      @media print { .stop { break-inside: avoid; } }
    </style>
  </head>
  <body>
    <div class="header">
      <h1>MAD Donuts - Delivery Route</h1>
      <div class="info">
        <strong>${route.route_number}</strong> | 
        ${new Date(route.delivery_date + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        ${route.driver_name ? ` | Driver: ${route.driver_name}` : ''}
      </div>
    </div>
    
    <div class="summary">
      <div class="summary-box">
        <div class="number">${route.total_stops}</div>
        <div class="label">Total Stops</div>
      </div>
      <div class="summary-box">
        <div class="number">${route.stops.reduce((sum, s) => sum + s.total_items, 0)}</div>
        <div class="label">Total Items</div>
      </div>
      <div class="summary-box">
        <div class="number">$${route.stops.reduce((sum, s) => sum + s.total_amount, 0).toFixed(2)}</div>
        <div class="label">Total Value</div>
      </div>
    </div>
    
    ${route.stops.map((stop, index) => `
      <div class="stop">
        <div class="stop-header">
          <div>
            <span class="stop-number">Stop #${stop.stop_number}</span>
            <span style="margin-left: 10px;">${stop.order_number}</span>
          </div>
          <div class="checkbox"></div>
        </div>
        <div class="stop-content">
          <div class="client-name">${stop.client_name}</div>
          <div class="address">📍 ${stop.delivery_address || 'No address'}</div>
          ${stop.delivery_time_window ? `<div class="time-slot">🕐 ${stop.delivery_time_window}</div>` : ''}
          ${stop.delivery_instructions ? `<div class="instructions">⚠️ ${stop.delivery_instructions}</div>` : ''}
          <div class="items">
            ${stop.items.map(item => `
              <div class="item">
                <span>${item.product_name}</span>
                <span><strong>${item.quantity}</strong> ${item.pack_size || ''}</span>
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    `).join('')}
    
    <div style="margin-top: 30px; text-align: center; font-size: 10px; color: #999;">
      Generated on ${new Date().toLocaleString()} • MAD Donuts Delivery System
    </div>
  </body>
  </html>
`;
